import { IRetryPolicy } from '@microsoft/signalr';

const retryDelays = [5000, 5000, 5000, 5000, 5000, 5000, 30000, 60000, 60000, 120000];

const signalRRetryPolicy: IRetryPolicy = {
  nextRetryDelayInMilliseconds: ({ previousRetryCount }) => retryDelays[Math.min(previousRetryCount, retryDelays.length - 1)],
};

export default signalRRetryPolicy;
